import axios, { AxiosError } from 'axios';
import Cookies from 'universal-cookie';

import { config } from './config';
import { paths } from './paths';

export const useApi = () => {
  const cookies = new Cookies();
  const token = cookies.get('User-Token');

  const api = axios.create({
    headers: {
      'Content-Type': 'application/json',
      Authorization: config.API_TOKEN,
      'x-api-key': config.GATEWAY_API_KEY,
      usertoken: token
    }
  });

  api.interceptors.request.use(
    (config: any) => config,
    (error: AxiosError) => {
      return Promise.reject(`~/services/api Request -> ${JSON.stringify(error, null, 4)}`);
    }
  );

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          // REFRESH TOKEN
        }
      }
      return Promise.reject(error);
    }
  );

  return {
    api,
    paths
  };
};
